import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    parentProjects: [],
    projectTree: [],
    projects: [],
    activeProject: null,
    order: [],
    error: null,
    loading: false,
    children: {}
};

const getEventRoomTreeStart = (state, action) => {
    return updateObject(state, { error: null, loading: true });
}

const getEventRoomTreeFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    });
}

const getChildren = ({ level, root, allProjects, parentProjects, projects }) => {
    let children = [];
    let length = 0;
    if (level.children.length > 0) {
        level.children.forEach((item, index) => {
            if (!root) parentProjects.push(item.project.getId());
            let _item = item.project;
            _item.root = root ? root : item.project.getId();
            updateObject(_item, item.project.data.metadata.fields);
            _item['created'] = item.project.metadata.fields.created;
            _item.originalObject = _item;
            children[length] = _item;
            let res = getChildren({ level: item, root: _item.root, allProjects, parentProjects, projects });
            children[length]['children'] = res.children;
            allProjects[item.project.getId()] = _item;
            projects.push({ ..._item.data, name: _item.name || '' });
            length++;
        });
    }
    return { children, allProjects, parentProjects, projects };
}

const getEventRoomTreeSuccess = (state, action) => {
    const allProjects = {};
    const parentProjects = [];
    const projects = [];
    let result = getChildren({ level: action, root: null, allProjects, parentProjects, projects });
    return updateObject(state, {
        parentProjects: result.parentProjects,
        projectTree: result.children,
        allProjects: result.allProjects,
        loading: false,
        projects: result.projects
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.EVENTROOMS_GET_PROJECT_TREE_START:
            return getEventRoomTreeStart(state, action);
        case actionTypes.EVENTROOMS_GET_PROJECT_TREE_SUCCESS:
            return getEventRoomTreeSuccess(state, action);
        case actionTypes.EVENTROOMS_GET_PROJECT_TREE_FAIL:
            return getEventRoomTreeFail(state, action);
        default:
            return state;
    }
}

export default reducer;
